import { api } from "./api";
import { safeNext } from "./authRedirect";
import { getPendingCohortCode, getPendingCohortInvite } from "./pendingCohort";

type Pushable = { push: (href: string) => void };

// Giriş/kayıt sonrası tek yönlendirme noktası. Sıra: e-posta doğrulama →
// KVKK + Açık Rıza onayı → dashboard. Doğrulanmamış hesap /verify-email'e,
// onayı olmayan ya da ESKİ SÜRÜMÜ onaylamış olan /consent'e gider.
//
// Kapı sürüm karşılaştırmasına dayanır: backend `consent_current` alanını
// kabul edilen sürümü yürürlükteki LEGAL_VERSION ile kıyaslayarak döndürür.
// Metin sürümü artınca herkes bir kez daha bu ekrandan geçer. Reddetme yoktur,
// kabul edilmeden hiçbir sayfaya geçilemez, çıkıp tekrar girmek de aynı ekrana
// çıkar. Aynı kapı backend'de de var (403 `consent_required`), yani bu yalnızca
// kullanıcıya kibar yolu gösterir, güvenliği o taşımaz.
//
// `next` (F18): ölü token yüzünden giriş ekranına düşen kişinin kaldığı sayfa.
// Yalnızca bütün kapılar geçildikten sonra ve bekleyen kohort rızası yoksa
// uygulanır; `safeNext` dışı bir değer sessizce dashboard'a düşer.
export async function routeAfterAuth(router: Pushable, next?: string | null): Promise<void> {
  try {
    const me = await api.getMe();
    if (!me.email_verified) router.push("/verify-email");
    else if (!me.consent_current) router.push("/consent");
    else {
      // Genel onay verildikten SONRA, bekleyen bir kohort kodu ya da kişisel
      // daveti varsa kohortun ayrı açık rıza ekranı gelir. Sıra bilerek böyle:
      // kohort rızası genel onayın üstüne binen ek bir rızadır, onun yerine
      // geçemez. Kişisel davet paylaşımlı kodun ÖNÜNE geçer: koltuk o kişi için
      // ayrılmıştır ve token tek kullanımlıktır.
      const invite = getPendingCohortInvite();
      const pending = getPendingCohortCode();
      if (invite) router.push(`/cohort-consent?invite=${encodeURIComponent(invite)}`);
      else if (pending) router.push(`/cohort-consent?code=${encodeURIComponent(pending)}`);
      else router.push(safeNext(next) ?? "/dashboard");
    }
  } catch {
    // /me başarısızsa güvenli varsayılan: onay ekranı.
    router.push("/consent");
  }
}
